import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from "react-router-dom";
import "./index.css";
import { checkHealth } from "./services/healthService";

import LoginPage from "./pages/loginPage";
import RegisterPage from "./pages/registerPage";
import ForgotPasswordPage from "./pages/forgotPasswordPage";
import ResetPasswordPage from "./pages/resetPasswordPage";
import DashboardPage from "./pages/dashboardPage";
import DocumentsPage from "./pages/documentsPage";
import Navbar from "./components/navbar";
import Toast from "./components/Toast";
import { getCurrentUser } from "./services/authService";
import WakeUpScreen from "./pages/WakeUpScreen";

/* Layout that includes Navbar */
function AppLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
}

/* Redirects to login if not authenticated */
function ProtectedRoute() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    getCurrentUser().then(setUser);
  }, []);

  if (user === undefined) return null; // still checking
  if (!user) return <Navigate to="/" replace />;
  return <AppLayout />;
}

function App() {

  const [serverReady, setServerReady] = useState(false)

  useEffect(() => {
    const saved = localStorage.getItem("theme");
    if (saved) document.documentElement.setAttribute("data-theme", saved);
  }, []);

  useEffect(() => {
    const poll = async () => {
      try {
        const ok = await checkHealth();
        if (ok) {
          setServerReady(true);
          clearInterval(interval);
        }
      }
      catch {}
    }

    const interval = setInterval(poll, 2000);
    poll();
    
  }, []);


  if (!serverReady) return <WakeUpScreen />; 
  return (
    <Router>
      <Toast />
      <Routes>
        {/* Auth pages (NO navbar) */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* App pages (WITH navbar, protected) */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/documents" element={<DocumentsPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
